import firebase from 'firebase'

const firebaseApp = firebase.initializeApp({
    apiKey: "AIzaSyAt2HMWXHf_NJcWyTqRr-YrsHGG0Ts8AnU",
    authDomain: "groupchat-53a8a.firebaseapp.com",
    projectId: "groupchat-53a8a",
    storageBucket: "groupchat-53a8a.appspot.com",
    messagingSenderId: "892125223366",
    appId: "1:892125223366:web:6e67924e5a42ced865bac7",
    measurementId: "G-64QB9675W2"
})

const db = firebaseApp.firestore()

const auth = firebase.auth()

export { db, auth }